import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class RegexService {
  numberPattern         : string = '[0-9]+'
  decimalPattern        : string = '[0-9]+([.][0-9]{1,2})?'
  mobilePattern         : string = '[1-9][0-9]{9}'
  alphabeticPattern     : string = '[a-zA-Z]+'
  alphanumericPattern   : string = '[a-zA-Z0-9]+'
  pinCodePattern        : string = '[1-9][0-9]{5}'
  userNamePattern       : string = '([a-zA-Z]+[.]?)+( [a-zA-Z]+)*'
  hospitalNamePattern   : string = '[a-zA-Z0-9&\'()_@-]+( [a-zA-Z0-9&\'()_@-]+)*'
  emailPattern          : string = '^[a-zA-Z0-9.!#$%&\'*+ /= ?^_`{|}~-]+@[a-zA-Z0-9-]+[.][a-zA-Z0-9-.]{2,6}$'
  wsnPattern            : string = '[a-zA-Z][0-9]{6}'
  vpa                   : string = '[a-zA-Z0-9.-]{2,256}@[a-zA-Z][a-zA-Z]{2,64}$'
  ifscCode              : string = '[A-Z]{4}0[A-Z0-9]{6}$'
  accountName           : string = '^[a-zA-Z0-9\\s]+$'
  urlPattern            : string = '^(https?:\\/\\/)([\\w-]+\\.)+[\\w-]+(:\\d+)?(\\/[^\\s]*)?(\\?[^\\s#]*)?(#[\\w-]*)?$';
}
